// <s-newsletter-popup>: opens its <dialog> once per visitor after a delay, and reopens it to show the signup result.
class SNewsletterPopup extends HTMLElement {
  #dialog;
  #timer;
  #ac;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    if (!this.#dialog) return;

    this.#ac = new AbortController();
    const storageKey = this.dataset.storageKey || 'newsletter-popup-seen';
    const delay = Number(this.dataset.delay || 6000);
    const params = new URLSearchParams(window.location.search);
    const hasResult = params.get('customer_posted') === 'true' || this.#dialog.querySelector('[role="alert"]');

    this.#dialog.addEventListener('close', () => this.#remember(storageKey), { signal: this.#ac.signal });

    if (hasResult) {
      this.#open();
      return;
    }

    if (this.hasAttribute('data-design-mode') || this.#seen(storageKey)) return;
    this.#timer = window.setTimeout(() => this.#open(), delay);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.#ac?.abort();
  }

  #open() {
    if (!this.#dialog.open && !document.querySelector('dialog[open]')) this.#dialog.showModal();
  }

  #seen(key) {
    try {
      return window.localStorage.getItem(key) === '1';
    } catch {
      return false;
    }
  }

  #remember(key) {
    try {
      window.localStorage.setItem(key, '1');
    } catch {
      // Storage can be unavailable in private mode; the popup simply shows again next visit.
    }
  }
}

if (!customElements.get('s-newsletter-popup')) customElements.define('s-newsletter-popup', SNewsletterPopup);
